import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import  './Resources/Actions.css';
import './App.css';

export default function Defaulters(){
   
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const date = new Date().toISOString().slice(0,10);
    const [dlist,setDlist] = useState([]);
    const [odlist,setOdlist] = useState([]);
    const navigate = useNavigate();
    const [dvalue, setDvalue] = useState("a");

    

    useEffect(()=>{
        fetch(API_URL+"api/Defaulters/FindCurrentDateDefaulters?date="+date)
        .then(response => response.json())
        .then(data => {setDlist(data)});

        fetch(API_URL+"api/Defaulters/FindDefaulters?date="+date)
        .then(response => response.json())
        .then(data => {setOdlist(data)});
    },[])


    const Total = odlist.reduce((tot,el)=>tot+ el.LoanBalance,0);
    const instotal = dlist.reduce((tot,el)=>tot+ el.InstallmentAmount,0);

    return(
        <>
        <div className="reportheader"> 
            Defaulters Report
            <Navbar/>
        </div> 
        
        <div >
    <fieldset >
         <label for = "rdate">Report Date</label>
         <input id = "rdate" type="date" defaultValue = {date} style = {{height :"25px",width:"150px",marginLeft:"5px" }} readOnly ></input><br /><br/>
         <label for = "default">Select Type</label>
         <select id = "default" value = {dvalue}  style = {{height :"30px",width:"155px",marginLeft:"10px" }} onChange={(e)=>{setDvalue(e.target.value)}}>
            <option value = "a" > Day</option>
            <option value = "b" > Over Due</option>
         </select> 
    
    </fieldset>    
      
      <table style={{width:"100%",marginTop:"5px",backgroundColor:"lightskyblue",marginBottom:"40px"}} >

        {(dvalue === "a") ? <>
                
            <tr>
                   <th>C.ID</th>
                   <th>C.Name</th>
                   <th>I.Amt</th>
                   <th>Balance</th>
            </tr>

                {dlist.map(cus=>{return( 
                <tr>
                <td style ={{width:"30px"}}>{cus.CustomerID}</td>
                <td style ={{width:"180px",textAlign:"left"}}>{cus.CustomerName},{cus.Address}</td>
                <td style ={{width:"50px"}}>{cus.InstallmentAmount}</td>
                <td style ={{width:"95px"}}>{cus.LoanBalance}</td>
                </tr>)})}
                
                <tr>
                <td></td>
                <td>Total</td>
                <td>{instotal}</td>
                <td></td>
                </tr>  </> :  <>
            
            <tr>
                 <th>C.ID</th>
                 <th>C.Name</th> 
                 <th>C.Date</th>
                 <th>Balance</th>
            </tr>

                {odlist.map(cus=>{return(
            <tr>
                <td style ={{width:"30px"}}>{cus.CustomerID}</td>
                <td style ={{width:"160px",textAlign:"left"}}>{cus.CustomerName},{cus.Address}</td>
                <td style ={{width:"100px"}}>{cus.DateOfLoanClosing.slice(0,10)}</td>
                <td style ={{width:"65px"}}>{cus.LoanBalance}</td>
            </tr>)})} 
            <tr>
                <td></td>
                <td></td>
                <td>Total</td>
                <td>{Total}</td>
            </tr>
            </> }
      </table>

      </div>
      <button type="button" className="backbutton" onClick={()=>{navigate('/loandetails')}}>Back</button>
      </>
    )
}